import { render, staticRenderFns } from "./unit-devices-link.vue?vue&type=template&id=716846ce&"
import script from "./unit-devices-link.vue?vue&type=script&lang=js&"
export * from "./unit-devices-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports